/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyBillingAddress } from './';
import {
    CompanyBillingAddressFromJSON,
    CompanyBillingAddressFromJSONTyped,
    CompanyBillingAddressToJSON,
} from './';
import type { CompanyIdentityDataResource } from './';
import {
    CompanyIdentityDataResourceFromJSON,
    CompanyIdentityDataResourceFromJSONTyped,
    CompanyIdentityDataResourceToJSON,
} from './';
import type { CompanyLegalInformation } from './';
import {
    CompanyLegalInformationFromJSON,
    CompanyLegalInformationFromJSONTyped,
    CompanyLegalInformationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyBillingInformationResource
 */
export interface ClientCompanyBillingInformationResource {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationResource
     */
    legalName?: string;
    /**
     * 
     * @type {CompanyBillingAddress}
     * @memberof ClientCompanyBillingInformationResource
     */
    address?: CompanyBillingAddress;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationResource
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationResource
     */
    legalInformationStatus?: ClientCompanyBillingInformationResourceLegalInformationStatusEnum;
    /**
     * 
     * @type {CompanyLegalInformation}
     * @memberof ClientCompanyBillingInformationResource
     */
    legalInformationReplacementSuggestion?: CompanyLegalInformation;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationResource
     */
    registrationOfficeInformation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientCompanyBillingInformationResource
     */
    hasMandatoryInformation?: boolean;
    /**
     * True when the company has been identified and edits of registration/VAT numbers are blocked for CLIENT actors. False otherwise (unidentified, or feature-flag off for the organization).
     * @type {boolean}
     * @memberof ClientCompanyBillingInformationResource
     */
    isIdentifierEditLocked?: boolean;
    /**
     * 
     * @type {CompanyIdentityDataResource}
     * @memberof ClientCompanyBillingInformationResource
     */
    companyIdentityData?: CompanyIdentityDataResource;
}


/**
 * @export
 */
export const ClientCompanyBillingInformationResourceLegalInformationStatusEnum = {
    Match: 'MATCH',
    PartialMatch: 'PARTIAL_MATCH',
    NotSync: 'NOT_SYNC'
} as const;
export type ClientCompanyBillingInformationResourceLegalInformationStatusEnum = typeof ClientCompanyBillingInformationResourceLegalInformationStatusEnum[keyof typeof ClientCompanyBillingInformationResourceLegalInformationStatusEnum];


/**
 * Check if a given object implements the ClientCompanyBillingInformationResource interface.
 */
export function instanceOfClientCompanyBillingInformationResource(value: object): value is ClientCompanyBillingInformationResource {
    return true;
}

export function ClientCompanyBillingInformationResourceFromJSON(json: any): ClientCompanyBillingInformationResource {
    return ClientCompanyBillingInformationResourceFromJSONTyped(json, false);
}

export function ClientCompanyBillingInformationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyBillingInformationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'address': json['address'] == null ? undefined : CompanyBillingAddressFromJSON(json['address']),
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'legalInformationStatus': json['legalInformationStatus'] == null ? undefined : json['legalInformationStatus'],
        'legalInformationReplacementSuggestion': json['legalInformationReplacementSuggestion'] == null ? undefined : CompanyLegalInformationFromJSON(json['legalInformationReplacementSuggestion']),
        'registrationOfficeInformation': json['registrationOfficeInformation'] == null ? undefined : json['registrationOfficeInformation'],
        'hasMandatoryInformation': json['hasMandatoryInformation'] == null ? undefined : json['hasMandatoryInformation'],
        'isIdentifierEditLocked': json['isIdentifierEditLocked'] == null ? undefined : json['isIdentifierEditLocked'],
        'companyIdentityData': json['companyIdentityData'] == null ? undefined : CompanyIdentityDataResourceFromJSON(json['companyIdentityData']),
    };
}

export function ClientCompanyBillingInformationResourceToJSON(value?: ClientCompanyBillingInformationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalName': value['legalName'],
        'address': CompanyBillingAddressToJSON(value['address']),
        'vatNumber': value['vatNumber'],
        'registrationNumber': value['registrationNumber'],
        'legalInformationStatus': value['legalInformationStatus'],
        'legalInformationReplacementSuggestion': CompanyLegalInformationToJSON(value['legalInformationReplacementSuggestion']),
        'registrationOfficeInformation': value['registrationOfficeInformation'],
        'hasMandatoryInformation': value['hasMandatoryInformation'],
        'isIdentifierEditLocked': value['isIdentifierEditLocked'],
        'companyIdentityData': CompanyIdentityDataResourceToJSON(value['companyIdentityData']),
    };
}

